import api from './api.js';

export const surveysApi = {
  summary: async () => {
    const { data } = await api.get('/surveys/summary');
    return data;
  },
  list: async ({ limit = 50, offset = 0 } = {}) => {
    const { data } = await api.get('/surveys', { params: { limit, offset } });
    return data;
  },
};

export default surveysApi;
